<template>
  <div class="user">
    <div class="user-wrapper">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
      <menu-bar :class="{'no-nav': $route.meta.userNav===false}"></menu-bar>
    </div>
  </div>
</template>

<script>
import MenuBar from '@/components/user/MenuBar'

export default {
  components: {
    MenuBar,
  },
}
</script>

<style scoped lang="stylus">
.user-wrapper {
  min-height: calc(100vh - 64px);
  padding-bottom: 60px;
}

.no-nav {
  display: none;
}
</style>
